import { readMetaTotals, normalizeMetaCurrencyRow } from './metaAdsMoney';
import { metaNum } from './metaFormat';

const list = (v) => (Array.isArray(v) ? v : []);
const str = (v) => (typeof v === 'string' && v.trim() ? v.trim() : null);

/**
 * `getmetaresults` (scope=space) reducido a lo que usa la pestaña Informe: totales del espacio y una
 * fila por propiedad. Los anuncios compartidos cuentan **una vez** en los totales y **completos** en
 * cada propiedad, así que las filas no se suman nunca (`share_of_spend_pct` puede pasar de 100).
 *
 * @param {object} res envelope de `getMetaResults`
 * @returns {{ totals: ReturnType<typeof readMetaTotals>, units: Array<object>, coverage: object|null }}
 */
export function readMetaResults(res) {
  const data = res?.data && typeof res.data === 'object' ? res.data : {};
  const totals = readMetaTotals('unit', data);
  const units = list(data.units)
    .filter((u) => u && str(u.item_kind) && str(u.id))
    .map((u) => ({
      itemKind: str(u.item_kind),
      id: str(u.id),
      label: str(u.label),
      adsCount: metaNum(u.ads_count) ?? 0,
      activeAdsCount: metaNum(u.active_ads_count),
      sharedAdsCount: metaNum(u.shared_ads_count) ?? 0,
      currency: str(u.currency),
      mixedCurrencies: u.mixed_currencies === true,
      spend: metaNum(u.spend),
      contacts: metaNum(u.contacts) ?? 0,
      costPerContact: metaNum(u.cost_per_contact),
      byCurrency: list(u.by_currency).map(normalizeMetaCurrencyRow),
    }));
  const cov = data.coverage && typeof data.coverage === 'object' ? data.coverage : null;
  return { totals, units, coverage: cov };
}
